import React from "react";
import "./Loader.css";
const Loader = () => {
  return <div class="button-loader"></div>;
};

export default Loader;
